import { Observable, of } from 'rxjs';
import { catchError, map, startWith } from 'rxjs/operators';
import { Errored, Loaded, Loading, LoadingState } from '../types/loading.type';

export interface Loading {
  state: 'loading';
}

export interface Loaded<T> {
  state: 'loaded';
  data: T;
}

export interface Errored {
  state: 'error';
  error: Error;
}

export type LoadingState<T = any> = Loading | Loaded<T> | Errored;

export function toLoadingStateStream<T>(source$: Observable<T>): Observable<LoadingState<T>> {
  return source$.pipe(
    map((data) => ({ state: 'loaded', data } as Loaded<T>)),
    catchError((error) => of({ state: 'error', error } as Errored)),
    startWith({ state: 'loading' } as Loading)
  );
}



// WEBPACK FOOTER //
// ./src/utils/toLoadingStateStream.ts